export default __webpack_public_path__ + "static/media/bg-pattern.be38604a.svg";